import { pinia } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/pinia/instance.js?vue3';
import { RapidDiffsFacade } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/index.js?vue3';
import { adapters } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/adapter_configs/commit.js?vue3';
import { useCommitDiffDiscussions } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/stores/commit_discussions_store.js?vue3';
import axios from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/axios_utils.js?vue3';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import { s__ } from '~/locale';
import { initNewDiscussionToggle } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/init_new_discussions_toggle.js?vue3';
import { useDiffsView } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/stores/diffs_view.js?vue3';
import { INLINE_DIFF_VIEW_TYPE } from '~/diffs/constants';
import { initTimeline } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/init_timeline.js?vue3';
import { initHotkeys } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/init_hotkeys.js?vue3';
import TaskList from '/builds/gitlab/gitlab-ee/app/assets/javascripts/task_list.js?vue3';
import { UPDATE_COMMENT_FORM } from '~/notes/i18n';

class CommitRapidDiffsApp extends RapidDiffsFacade {
  adapterConfig = adapters;

  async init() {
    super.init();
    this.#initViewModeResize();
    await this.#initDiscussions();
    initHotkeys({ mergeRequestShortcuts: false });
  }

  /**
   * Adjusts the diffs container width when switching between inline and side-by-side view modes.
   *
   * Listens for view type changes via the diffs store and toggles the `container-limited` class
   * on the diffs container. Side-by-side/parallel view always renders full-width for diffs,
   * no matter user preferences (fluid/fixed width). So we do NOT toggle the class.
   */
  // eslint-disable-next-line class-methods-use-this
  #initViewModeResize() {
    useDiffsView().$onAction(({ name }) => {
      if (name !== 'updateViewType') return;
      const diffsContainer = document.querySelector('.js-fixed-layout');
      if (!diffsContainer) return;
      diffsContainer.classList.toggle(
        'container-limited',
        useDiffsView().viewType !== INLINE_DIFF_VIEW_TYPE,
      );
    });
  }

  async #initDiscussions() {
    try {
      const store = useCommitDiffDiscussions(pinia);
      store.setDiscussionsEndpoint(this.appData.discussionsEndpoint);
      const {
        data: { discussions },
      } = await axios.get(this.appData.discussionsEndpoint);
      store.setInitialDiscussions(discussions);
      initNewDiscussionToggle(this.root);
      initTimeline(this.appData);
      // eslint-disable-next-line no-new
      new TaskList({
        dataType: 'note',
        fieldName: 'note',
        selector: '[data-rapid-diffs]',
        onSuccess: ({ id, note }) => {
          store.updateNoteTextById(id, note);
        },
        onError: (error) => {
          createAlert({
            message: UPDATE_COMMENT_FORM.defaultError,
            error,
          });
        },
      });
    } catch (error) {
      createAlert({
        message: s__('RapidDiffs|Failed to load discussions. Try to reload the page.'),
        error,
      });
    }
  }
}

export const createCommitRapidDiffsApp = (options) => {
  return new CommitRapidDiffsApp(options);
};
